<template>
  <div :class="topClass">
    K3L
    <div :class="className">
      <label
        class="k3l-filter-label"
        v-for="(list, index) in k3lCategories"
        :key="index"
      >
        <input
          v-model="chooseK3lScore"
          type="checkbox"
          :value="list.id"
          style="margin-right: 10px"
          class="input-k3l-checkbox"
        />
        <div class="text-upper">
          {{ list.desc && list.desc.toLowerCase() }}
        </div>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  props: ['className', 'topClass'],
  computed: {
    k3lCategories() {
      return this.$store.state.k3lCategories
    },
    chooseK3lScore: {
      get: function() {
        return this.$store.state.searchStore.chooseK3lScore
      },
      set: function(newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'chooseK3lScore',
          value: newValue,
        })
      },
    },
  },
}
</script>
